var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { UXPContext } from "@core/context/Context";
import IconButton from './IconButton';
import ButtonComponent from "./ButtonComponent";
/**
 * This is a confirm button component.
 * @export
 *
 * @example
 * ```
 *  <ConfirmButton
 *      title="Delete Item"
 *      loading={buttonLoading}
 *      onConfirm={async () => {return executeAction("model", "action", {})}}
 *      onCancel={() => {alert("Canceled")}}
 *  />
 * ```
 *
 * @category Buttons
 */
const ConfirmButton = (props) => {
    var _a;
    // props
    let { onConfirm, onCancel } = props, rest = __rest(props, ["onConfirm", "onCancel"]);
    const context = useContext(UXPContext);
    // state
    let [show, setShow] = React.useState(false);
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        let p = new Promise((resolve, reject) => {
            onConfirm()
                .then(res => {
                resolve(res);
                setShow(false);
            })
                .catch(e => {
                reject(e);
            });
        });
        return p;
    });
    const handleCancel = () => {
        onCancel();
        setShow(false);
    };
    return (_jsx("div", { className: "uxpcore_confirmbutton", children: show ?
            _jsxs(_Fragment, { children: [_jsx(ButtonComponent, { title: "Confirm", onClick: handleConfirm, active: true }), _jsx(IconButton, { type: "close", ariaLabel: (_a = context === null || context === void 0 ? void 0 : context.$L) === null || _a === void 0 ? void 0 : _a.call(context, 'uxp-core.text.cancel'), onClick: handleCancel, variant: 'danger' })] })
            :
                _jsx(ButtonComponent, Object.assign({}, rest, { onClick: () => { setShow(true); } })) }));
};
export default ConfirmButton;
